export default {"src":"/_next/static/media/hamburguer.1def862a.svg","height":17,"width":18,"blurWidth":0,"blurHeight":0};